import React from 'react';
import { T } from '../../../../../../common/locale/translate';
import ClockIcon from '../../../../../icons/clock-icon';
import InfinityIcon from '../../../../../icons/infinity-icon';
import ElephantIcon from '../../../../../icons/elephant-icon';
import PassportIcon from '../../../../../icons/passport-icon';
import FamilyIcon from '../../../../../icons/family-icon';
import MapIcon from '../../../../../icons/map-icon';

class OffersNavigation extends React.Component {
  render() {
    const {
      loadAllInclusiveOffers,
      loadLastMinuteOffers,
      loadFromGermanyOffers,
      loadWithChildrenOffers,
      loadExoticPlacesOffers,
      loadWithoutPassportOffers,
      activeTab
    } = this.props;

    const getClass = tab => `link-offer ${activeTab === tab ? 'active' : ''}`;

    return (
      <ul className="nav-offers">
        <li className={getClass('all_inclusive')}>
          <a
            onClick={e =>
              this.handleLoadOffers(e, loadAllInclusiveOffers, 'all_inclusive')
            }
            title={T('all_inclusive')}
            href="#"
          >
            <InfinityIcon className="offers-icon" />
            {T('all_inclusive')}
          </a>
        </li>
        <li className={getClass('last_minute')}>
          <a
            onClick={e =>
              this.handleLoadOffers(e, loadLastMinuteOffers, 'last_minute')
            }
            title={T('last_minute')}
            href="#"
          >
            <ClockIcon className="offers-icon" />
            <span>{T('last_minute')}</span>
          </a>
        </li>
        <li className={getClass('exotic_places')}>
          <a
            onClick={e =>
              this.handleLoadOffers(e, loadExoticPlacesOffers, 'exotic_places')
            }
            title={T('exotic_places')}
            href="#"
          >
            <ElephantIcon className="offers-icon" />
            {T('exotic_places')}
          </a>
        </li>
        <li className={getClass('without_passport')}>
          <a
            onClick={e =>
              this.handleLoadOffers(
                e,
                loadWithoutPassportOffers,
                'without_passport'
              )
            }
            title={T('without_passport')}
            href="#"
          >
            <PassportIcon className="offers-icon" />
            {T('without_passport')}
          </a>
        </li>
        <li className={getClass('with_children')}>
          <a
            onClick={e =>
              this.handleLoadOffers(e, loadWithChildrenOffers, 'with_children')
            }
            title={T('with_children')}
            href="#"
          >
            <FamilyIcon className="offers-icon" />
            {T('with_children')}
          </a>
        </li>
        <li className={getClass('from_germany')}>
          <a
            onClick={e =>
              this.handleLoadOffers(e, loadFromGermanyOffers, 'from_germany')
            }
            title={T('from_germany')}
            href="#"
          >
            <MapIcon className="offers-icon" />
            {T('from_germany')}
          </a>
        </li>
      </ul>
    );
  }

  handleLoadOffers(e, loadOffers, tab) {
    e.preventDefault();
    tab && this.props.setActiveTab(tab);
    loadOffers();
  }
}

export default OffersNavigation;



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/offers_navigation.jsx